import { Pipe, PipeTransform } from '@angular/core';

const WRAP_HEADER_TEXT_LENGTH = 20;

function wrapLine(line: string, maxLineLength: number): string[] {
    const wrappedLines: string[] = [];
    let currentLine = '';
    for (const word of line.split(/\s+/).filter(Boolean)) {
        if (currentLine && currentLine.length + 1 + word.length > maxLineLength) {
            wrappedLines.push(currentLine);
            currentLine = word;
        } else {
            currentLine = currentLine ? `${currentLine} ${word}` : word;
        }
    }
    if (currentLine) {
        wrappedLines.push(currentLine);
    }
    return wrappedLines;
}

@Pipe({
    name: 'wrapHeaderText',
    standalone: true,
})
export class WrapHeaderTextPipe implements PipeTransform {
    transform(text: string | null | undefined, maxLineLength = WRAP_HEADER_TEXT_LENGTH): string {
        return (text ?? '')
            .split('\n')
            .flatMap((line) => wrapLine(line, maxLineLength))
            .join('\n');
    }
}
